/* Nurtino article: mobile sticky product bar.
   Shows once the reader has scrolled past the mid-article CTA (or ~35% of the article if there is
   none), hides while the end CTA / footer is on screen, and stays dismissed for the session. */
(function () {
  "use strict";
  var bar = document.querySelector("[data-nt-sticky]");
  if (!bar || !("IntersectionObserver" in window)) return;
  var KEY = "nt-sticky-dismissed";
  try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}

  var mid = document.querySelector('[data-nt-cta="mid"]');
  var blockers = document.querySelectorAll('[data-nt-cta="end"], .nt-site-footer, .nt-related');
  var passedMid = false, blocked = 0, dismissed = false;

  function update() {
    var show = passedMid && blocked === 0 && !dismissed;
    if (show) { bar.hidden = false; requestAnimationFrame(function () { bar.classList.add("is-on"); }); }
    else { bar.classList.remove("is-on"); }
  }

  if (mid) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        // passed = the card has scrolled above the viewport top
        passedMid = !en.isIntersecting && en.boundingClientRect.top < 0;
      });
      update();
    }).observe(mid);
  } else {
    window.addEventListener("scroll", function () {
      var doc = document.documentElement;
      passedMid = window.scrollY > (doc.scrollHeight - window.innerHeight) * 0.35;
      update();
    }, { passive: true });
  }

  var seen = new Set();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target); });
    blocked = seen.size;
    update();
  });
  blockers.forEach(function (el) { io.observe(el); });

  bar.querySelector(".nt-sticky__x").addEventListener("click", function () {
    dismissed = true;
    try { sessionStorage.setItem(KEY, "1"); } catch (e) {}
    update();
  });
})();
